import { ModelBase } from "../../pillar/common/models/ModelBase";


export class JobExportModel extends ModelBase {
  static readonly $typeName = 'JobExportModel';
  public startDate: string;
  public endDate: string;
  public submittingEntityKey: string;
  public submittingEntityName: string;
  public url: string;

}



// WEBPACK FOOTER //
// ./src/app/submission/models/JobExportModel.ts